<template>
  <div>
    <el-select  v-loading="loading" filterable class="select-primary" size="large" placeholder="Selecione ..." v-model="eventIdSelected" name="eventIdSelected">
      <el-option class="select-primary" value="all" label="Todos"></el-option>
      <el-option v-for="item in events" filterable class="select-primary" :value="item._id" :label="`${item.reference} - ${item.city}`" :key="item._id"></el-option>
    </el-select>

    <button v-loading="loading" @click="handleGenerate()" class="btn btn-info btn-fill btn-wd">Gerar tickets para o evento</button>

    <el-progress :percentage="progressPercentage"></el-progress>
  </div>
</template>
<script>
import _ from 'lodash'
import Couchdb from 'src/services/Couchdb'
import swal from 'sweetalert2'

export default {
  name: 'generate-new-tickets',

  data () {
    return {
      period: {start: '', end: ''},
      customers: [],
      eventsFetched: [],
      countTickets: 0,
      eventIdSelected: '',
      loading: false,
      progress: 0,
      total: 0
    }
  },
  computed: {
    events: {
      get () {
        return this.$store.state.events.all
      }
    },

    eventSelected () {
      return this.events.find(item => item._id === this.eventIdSelected)
    },

    progressPercentage () {
      if (this.total === 0) {
        return 0
      }
      return parseInt((this.progress / this.total) * 100)
    }
  },
  methods: {
    handleGenerate () {
      this.loading = true
      this.total = 0
      this.fetchEventsByCity()
        .then(async (response) => {
          this.eventsFetched = response.rows.map(item => item.value)
          this.countTicketsEvent()
            .then(res => {
              this.countTickets = res.rows.filter(item => {
                return item.key === this.eventSelected._id
              }).reduce((acc, curr) => {
                return curr.value
              }, 0)

              this.fetchCustomers()
                .then(docs => {
                  this.handleFormGeneration(this.setCustomers(docs))
                })
                .catch(err => {
                  console.log(err)
                  this.loading = false
                })
            })
            .catch(err => console.log(err))
        })
    },

    setCustomers (docs) {
      for (let doc of docs) {
        let customers = doc.rows.map(item => item.value)
        for (let customer of customers) {
          this.customers.push(customer)
        }
      }
      this.total = this.customers.length
    },

    fetchEventsByCity () {
      return Couchdb.connection('default')
        .view({
          ddoc: 'events-by-city',
          view: 'events-by-city',
          key: this.eventSelected.city
        })
    },

    fetchCustomers () {
      return Promise.all(this.eventsFetched.map(event => {
        return Couchdb.connection('default')
          .viewBetween({
            ddoc: 'customers-by-createdAt',
            view: 'customers-by-createdAt',
            keys: {
              startKey: event.startDate,
              endKey: event.endDate
            },
            options: {reduce: false, skip: 0, descending: false, ascending: true}
          })
      }))
    },

    countTicketsEvent () {
      return Couchdb.connection('default')._viewReduce('events-count-tickets', 'events-count-tickets')
    },

    async handleFormGeneration () {
      this.formGeneration()
        .then((value) => {
          this.total = value
          this.progress = 0
          this.generateTickets(value)
        })
    },

    async formGeneration () {
      let countCustomers = this.customers.length
      return swal({
        title: 'Formulário para gerar tickets',
        html:
          `<p>Foram encontrados ${countCustomers} clientes cadastrados nos períodos dos eventos para este múnicipio: ${this.eventSelected.city}.</p>` +
          `<p>O evento ${this.eventSelected.reference} já possui ${this.countTickets} gerados.</p>` +
          `<p>Defina abaixo a quantidades de tickets a serem gerados:</p>` +
          '<input id="swal-qnt-tickets" type="number" max="' + countCustomers + '" class="swal2-input">',
        focusConfirm: false,
        preConfirm: function () {
          return new Promise((resolve) => {
            resolve(document.getElementById('swal-qnt-tickets').value)
          })
        }
      })
    },

    generateTickets (ammount) {
      this.verifyTickets(this.customers.map(customer => {
        return {
          eventId: this.eventSelected._id,
          customerId: customer._id,
          barcode: `${customer.uc}${_.random(10000000, 99999999)}`,
          collection: 'tickets',
          eligible: true,
          reasonNotEligible: '',
          stockId: null,
          winner: false,
          documentedAt: null,
          checkIn: false,
          createAt: new Date()
        }
      }), ammount)
        .then(docs => {
          let tickets = docs.slice(0, ammount)
          this.askConfirmation(tickets)
            .then(confirm => {
              if (confirm) {
                this.runInsert(tickets)
                  .then(() => this.notifyFinish())
                  .catch((err) => this.notifyFailure(err))
                  .finally(() => {
                    this.loading = false
                  })
              }
            })
        })
    },

    async verifyTickets (tickets, ammount) {
      tickets = await this.filterTicketsCreatedByCustomerId(tickets)
      this.total = tickets.length
      let ticketsValid = []
      for (let payload of tickets) {
        let results = await Couchdb.connection('default').view({ddoc: 'tickets-by-barcode', view: 'tickets-by-barcode', key: payload.barcode})
        let barcodeCheck = results.rows.map(item => item.value).find(item => item.barcode === payload.barcode)
        if (!barcodeCheck) {
          --ammount
          ticketsValid.push(payload)
        }
        if (ammount <= 0) {
          this.progress = this.total
          break
        }
        this.progress ++
      }
      return ticketsValid
    },

    async filterTicketsCreatedByCustomerId (tickets) {
      let eventTickets = await Couchdb.connection('default').view({ddoc: 'tickets-by-eventId', view: 'tickets-by-eventId', key: this.eventSelected._id})
      eventTickets = eventTickets.rows.map(item => item.value).reduce((acc, curr, index) => {
        if (index === 0) {
          acc = {}
        }
        acc[curr.customerId] = curr
        return acc
      }, {})
      return tickets.filter(item => {
        return !eventTickets.hasOwnProperty(item.customerId)
      })
    },

    runInsert (docs) {
      return Couchdb.connection('default')._insertBulk(docs)
    },

    askConfirmation (tickets) {
      return swal({
        title: `Confirmar criação de tickets`,
        html: `Vão ser gerados ${tickets.length} para este evento`,
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim! Crie os tickets!',
        cancelButtonText: 'Não! Cancele tudo!',
        confirmButtonClass: 'btn btn-danger btn-fill',
        cancelButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    },

    notifyFinish () {
      this.loading = false
      return swal({
        title: 'Sucesso',
        text: `Ação executada com sucesso.`,
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    },

    notifyFailure (err) {
      return swal({
        width: 1000,
        title: 'Ocorreu um erro ao executar essa ação.',
        text: JSON.stringify(err),
        type: 'error',
        confirmButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/commands/GenerateNewTickets.vue